export default __webpack_public_path__ + "static/media/EUROPE_terms.23d6c695.pdf";